module.exports = __webpack_public_path__ + "static/media/house.863674fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/house.mp3
// module id = 739
// module chunks = 0